import React, { useState, useEffect } from 'react';
import { Snackbar, Alert } from '@mui/material';
import errorLogger from '../../services/errorLogger.service';

const ErrorNotification: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    // Set up the error notification callback
    errorLogger.setErrorNotificationCallback((msg: string) => {
      setMessage(msg);
      setOpen(true);
    });

    // Initialize the error logger
    errorLogger.initialize();

    return () => {
      // Clean up on unmount
      errorLogger.setErrorNotificationCallback(null);
    };
  }, []);

  const handleClose = (_event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert
        onClose={handleClose}
        severity="error"
        sx={{ width: '100%' }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default ErrorNotification;